import {connect} from 'react-redux';
import {SliderSelectGroup as Component} from './SliderSelectGroup';
import {
  selectNewSequenceInGroup,
  submitQuestionAnswer,
} from '@learningblocks/exp-redux/lib/Actions';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    updateSelection: (params) => {
      dispatch(selectNewSequenceInGroup(params));
    },
    submitAnswer: (id, type) => {
      dispatch(submitQuestionAnswer(id, type));
    },
  };
}
const SliderSelectGroup = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

export {
  SliderSelectGroup as SliderSelectGroupWithRedux,
  Component as SliderSelectGroup,
};
